/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

export enum DiviVisitedIds {
  initialFinding = 'initialFinding',
  handover = 'handover',
}

export type DiviVisitedStatesType = DiviVisitedIds[];

export const DIVI_VISITED_STATE_STORAGE_KEY = 'DIVI_VISITED_STATE';
